export enum NoteType {
    Plain = 1,
    Highlight,
    Important
}
